import pvdCrosstown01 from './pvd-crosstown-01.jpg';
import pvdCrosstown02 from './pvd-crosstown-02.jpg';
import pvdCrosstown03 from './pvd-crosstown-03.jpg';
import pvdCrosstown04 from './pvd-crosstown-04.jpg';
import pvdCrosstown05 from './pvd-crosstown-05.jpg';
import pvdCrosstown06 from './pvd-crosstown-06.jpg';
import pvdCrosstown07 from './pvd-crosstown-07.jpg';
import pvdCrosstown08 from './pvd-crosstown-08.jpg';
import pvdCrosstown09 from './pvd-crosstown-09.jpg';
import pvdCrosstown10 from './pvd-crosstown-10.jpg';
import pvdCrosstown11 from './pvd-crosstown-11.jpg';
import pvdCrosstown12 from './pvd-crosstown-12.jpg';
import pvdCrosstown13 from './pvd-crosstown-13.jpg';
import pvdCrosstown14 from './pvd-crosstown-14.jpg';
import pvdCrosstown15 from './pvd-crosstown-15.jpg';

export const pvdCrosstownTrailPhotos = [
  pvdCrosstown01,
  pvdCrosstown02,
  pvdCrosstown03,
  pvdCrosstown04,
  pvdCrosstown05,
  pvdCrosstown06,
  pvdCrosstown07,
  pvdCrosstown08,
  pvdCrosstown09,
  pvdCrosstown10,
  pvdCrosstown11,
  pvdCrosstown12,
  pvdCrosstown13,
  pvdCrosstown14,
  pvdCrosstown15,
];

